import { render, staticRenderFns } from "./Clases.vue?vue&type=template&id=583bbcae"
import script from "./Clases.vue?vue&type=script&lang=js"
export * from "./Clases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports